// extracted by mini-css-extract-plugin
export default {"preloader":"f_Z_fUk","loader":"f_aa_a0l","rotation":"f_ab_10a"};